import React, {useState} from "react";
import "../SalesPackageStyles.scss";
import "./SalesSummaryPackage.scss";
import {SalesPackageOption} from "../SalesPackageOption";
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import {useMediaQuery} from "@material-ui/core";
import {VehicleGroup} from "../../../model/vehicle";
import {VehicleGroupSVG} from "../../VehicleGroupSvg";
import {premiumFormat} from "../../../utils/format";
import {strings} from "../../../strings/strings";
import { InstallmentPayment } from "../../InstallmentPayment/InstallmentPayment";

interface SalesSummaryPackage {
    vehicleGroup: VehicleGroup;
    name: string;
    premium: number;
    tarrificationProgram: string;
    options: React.ReactElement<SalesPackageOption>[]
}

export const SalesSummaryPackage = ({vehicleGroup, name, premium, tarrificationProgram, options}: SalesSummaryPackage) => {
    const isMobile = useMediaQuery('(max-width: 1023px)');
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const toggleIsOpen = () => {
        setIsOpen(!isOpen);
    };

    const renderDesktopInfo = () => {
        return (
            <>
                <div className={'sales-package__name'}>
                    <VehicleGroupSVG vehicleGroup={vehicleGroup}/>
                    <span>{name}</span>
                </div>

                <div className={'sales-package__options'}>
                    {options.map((value) => {
                        return React.cloneElement(value, {
                            ...value.props
                        })
                    })}
                </div>

                <div className={'sales-package__premium'}>
                    <span>{`${premiumFormat(premium)} ${strings.currencyUAH}`}</span>
                </div>
                <span className={"sales-package__installment-alt"}>
                    {strings.installmentAlternative}
                </span>
                <InstallmentPayment installmentCount={3}
                                    fullAmount={premium} />
            </>
        );
    };

    const renderMobileInfo = () => {
        return (
            <>
                <div className={'sales-package__name'} onClick={toggleIsOpen}>
                    <VehicleGroupSVG vehicleGroup={vehicleGroup}/>
                    <span>{name}</span>
                    {isOpen ? <KeyboardArrowUpIcon/> : <KeyboardArrowDownIcon/>}
                </div>

                {isOpen && <>
                    <div className={'sales-package__options'}>
                        {options.map((value) => {
                            return React.cloneElement(value, {
                                ...value.props
                            })
                        })}
                    </div>

                    <div className={'sales-package__premium'}>
                        <span>{`${premiumFormat(premium)} ${strings.currencyUAH}`}</span>
                    </div>
                    <span className={"sales-package__installment-alt"}>
                        {strings.installmentAlternative}
                    </span>
                    <InstallmentPayment size={"medium"}
                                        installmentCount={3}
                                        fullAmount={premium} />
                </>}
            </>
        );
    };

    return (
        <div className="sales-summary-package">
            {isMobile && <h1>{strings.yourOrder}</h1>}
            <div className="sales-package sales-package--summary">
                {isMobile ? renderMobileInfo() : renderDesktopInfo()}
            </div>
        </div>
    )
};